import React, { useState, useEffect, useRef, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

//import './css/dd_sel.css';

class Wnd_Ok extends React.Component {
  constructor(props, context) {
    super(props);

    this.node = React.createRef();
    //this.setNodeRef = this.setNodeRef.bind(this);

    this.state = {};
    this.state.cols = {};
    this.state.sel_show = false;
    this.state.sel_step = 0;
  }

  componentDidUpdate() {
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick);
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick);
  }

  handleClick = (e) => {
    if(!this.props.msg.ok) return;

    if (!this.node.current.contains(e.target)) {
      //this.setState({sel_show: false});
      //this.props.ctx.setState({ wnd_ok: false });
      return;
    }
  }
  render() {
    if(!this.props.msg.ok) return "";

    const okwnd = {
      position: 'absolute',
      width: '35%',
      height: '35%',
      zIndex: '19999',
      top: '35%',
      left: '35%',
        border: "1px solid #ccc",
        borderRadius: "5px",
       backgroundColor: "#015d00",
        backgroundImage: "linear-gradient(314deg, #015d00 0%, #04bf00 74%)"
    }

    var title = this.props.title;
    if(!title) title = "URVAL";

	var html =
        <div ref={this.node} style={ okwnd } className="d-flex flex-column align-content-center justify-content-center text-center" >
        <h2 className="" style={{color: "#fff"}}>
            { this.props.msg.text }
        </h2>
        <FontAwesomeIcon className="" icon="check" size="4x" style={{color: "#fff"}} />

        </div>
	;
	return html;
  };
}

export default Wnd_Ok;